import { render, staticRenderFns } from "./MyGooglePrivacy.vue?vue&type=template&id=684d2d96&scoped=true"
import script from "./MyGooglePrivacy.vue?vue&type=script&lang=js"
export * from "./MyGooglePrivacy.vue?vue&type=script&lang=js"
import style0 from "./MyGooglePrivacy.vue?vue&type=style&index=0&id=684d2d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684d2d96",
  null
  
)

export default component.exports